export default "__VITE_ASSET__B8wE3kY2__"